import { render, staticRenderFns } from "./MyResources.vue?vue&type=template&id=01993db4"
import script from "./MyResources.vue?vue&type=script&lang=js"
export * from "./MyResources.vue?vue&type=script&lang=js"
import style0 from "./MyResources.vue?vue&type=style&index=0&id=01993db4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports